import { render } from "./StudentStudyMaterial.vue?vue&type=template&id=0003b8a4"
import script from "./StudentStudyMaterial.vue?vue&type=script&lang=js"
export * from "./StudentStudyMaterial.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__